import {
  ComponentFactoryResolver,
  ComponentRef,
  ViewContainerRef,
} from '@angular/core';
import { EventService } from 'src/app/events/services/event.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { SliderMultimediaComponent } from 'src/app/shared/components/slider-multimedia/slider-multimedia.component';

export type ResponseCreateMultimedia =
  | {
      componentRef: ComponentRef<any>;
      error: null;
    }
  | { componentRef: null; error: string };

export function addMultimediaComponentAsideMap(
  event: any,
  eventService: EventService,
  resolver: ComponentFactoryResolver,
  container: ViewContainerRef,
  vehicleService: VehicleService
): ResponseCreateMultimedia {
  // Debug completo del evento
  // logEventForMultimedia(event, eventService);
  if (
    event.parametros?.gps === 'cipia' &&
    (event.parametros.has_video !== '0' ||
      event.parametros.has_image !== '0' ||
      eventService.videoDemandInEvents[event.evento]) &&
    event.evento != 'checklist-daily'
  ) {
    try {
      const factory = resolver.resolveComponentFactory(
        SliderMultimediaComponent!
      );
      const componentRef: ComponentRef<any> =
        container.createComponent(factory);

      const params: any = {
        event: event,
        driver:
          vehicleService.vehicles.find((vh) => vh.IMEI == event.imei)
            ?.namedriver ?? '',
        showMultimediaFirst: true,
        hasMultimedia: true,
        showTitle: false,
      };

      console.log('(HISTORY) params', params);

      Object.keys(params).forEach((key) => {
        componentRef.instance[key] = params[key];
      });

      return { componentRef, error: null };
    } catch (error) {
      return { componentRef: null, error: error as string };
    }
  } else {
    console.log(
      '(MULTIMEDIA) No se pudo crear el componente multimedia - no cumple criterios'
    );
    return {
      componentRef: null,
      error: 'No se pudo crear el componente multimedia - no cumple criterios',
    };
  }
}
